var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',_vm._g(_vm._b({attrs:{"fileList":_vm.fileList,"after-read":_vm.afterRead,"multiple":"","max-count":_vm.maxCount}},'van-uploader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }